import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { getToken } from './auth/get-token';
import { loadCart } from './cart/load-cart';
import { AuthErrorCodes } from '../../types';
export var useHelper = function useHelper(dispatch, getState) {
  function withAuth(fn) {
    var getRefreshedAuthToken = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(getToken());
            case 2:
              return _context.abrupt("return", getState().auth.token);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getRefreshedAuthToken() {
        return _ref.apply(this, arguments);
      };
    }();
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var authToken,
        _len,
        args,
        _key,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            authToken = getState().auth.token;
            if (authToken) {
              _context2.next = 5;
              break;
            }
            _context2.next = 4;
            return getRefreshedAuthToken();
          case 4:
            authToken = _context2.sent;
          case 5:
            for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args2[_key];
            }
            _context2.prev = 6;
            _context2.next = 9;
            return fn.apply(void 0, [authToken].concat(args));
          case 9:
            return _context2.abrupt("return", _context2.sent);
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](6);
            if (!((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.code) === AuthErrorCodes.Unauthorized)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 17;
            return getRefreshedAuthToken();
          case 17:
            authToken = _context2.sent;
            if (!authToken) {
              _context2.next = 20;
              break;
            }
            return _context2.abrupt("return", fn.apply(void 0, [authToken].concat(args)));
          case 20:
            throw _context2.t0;
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 12]]);
    }));
  }
  function withCart(fn) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _getState,
        cart,
        _len2,
        args,
        _key2,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _getState = getState(), cart = _getState.cart;
            if (cart.data.id) {
              _context3.next = 5;
              break;
            }
            _context3.next = 4;
            return dispatch(loadCart());
          case 4:
            cart = getState().cart;
          case 5:
            for (_len2 = _args3.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = _args3[_key2];
            }
            return _context3.abrupt("return", fn.apply(void 0, [cart.data].concat(args)));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  }
  return {
    withAuth: withAuth,
    withCart: withCart
  };
};